import React from 'react';
import styled from 'styled-components/native';
import PropTypes from 'prop-types';
import Text from '../text';
import Colors from '../colors';
import Button from '../button';
import Icon from '../icon';
const StyledContainer = styled.View`
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;
export default function SectionTitle(props) {
  return /*#__PURE__*/React.createElement(StyledContainer, null, /*#__PURE__*/React.createElement(Text.BodyBase, {
    weight: "medium",
    color: Colors.gray400
  }, props.name), !props.noTextButton && /*#__PURE__*/React.createElement(Button.Text, {
    icon: props.icon,
    iconFamily: props.iconFamily,
    onPress: props.onPress,
    purpleIcon: true,
    disabled: props.disabled
  }, props.children));
}
SectionTitle.propTypes = {
  children: PropTypes.string,
  name: PropTypes.string,
  icon: PropTypes.string,
  iconFamily: PropTypes.elementType,
  onPress: PropTypes.func,
  noTextButton: PropTypes.bool,
  disabled: PropTypes.bool
};
SectionTitle.defaultProps = {
  children: '',
  name: '',
  icon: '',
  iconFamily: Icon.MaterialIcons,
  onPress: () => {},
  noTextButton: false,
  disabled: false
};
//# sourceMappingURL=index.js.map